import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export const CompanyLogo = ({ hasLogo, className = "", refreshKey = 0, fallback = null }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let obj;
    if (hasLogo) {
      api.get("/company/logo-image", { responseType: "blob" })
        .then((r) => { obj = URL.createObjectURL(r.data); setSrc(obj); })
        .catch(() => setSrc(null));
    } else {
      setSrc(null);
    }
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [hasLogo, refreshKey]);
  if (src) return <img src={src} alt="Company logo" className={className} style={{ objectFit: "contain" }} data-testid="company-logo-img" />;
  return fallback;
};
